import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconMyLocation$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconMyLocation extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'eb397959515774ed66c3314988f76f1c851479f0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7da5435dd24a0ad4c82aac7e407351a43ff67fd6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '12bba22e6903016398817a3995af901829f653fb', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.023 5.85a2.93 2.93 0 0 1 3-2.85 2.93 2.93 0 0 1 3 2.85c0 1.5-.58 2.49-2.8 5.75a.31.31 0 0 1-.51 0c-2.11-3.17-2.69-4.23-2.69-5.75m2 .15a1 1 0 1 0 2 0 1 1 0 0 0-2 0m7.37 3.34 2.63 8a.5.5 0 0 1-.52.66h-17a.51.51 0 0 1-.48-.66l2.66-8a.51.51 0 0 1 .47-.34h1.71a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.95l-2 6h14.26l-2-6h-.95a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.68a.5.5 0 0 1 .49.34", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-my-location", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-my-location"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-my-location":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconMyLocation$1);
            }
            break;
    } });
}

const CosmosIconMyLocation = CosmosIconMyLocation$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconMyLocation, defineCustomElement };
